module.exports = {
  language: 'Spanish',
  nationalityKay: 'es-es',
  personal: {
    purgePopupContent:
      'Lo sentimos, los datos de su solicitud se han eliminado debido a la política de seguridad, puede comunicarse con nosotros si desea presentar su solicitud pronto'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Por favor seleccione',
  multiselect: {
    deselect: 'Presione Enter para eliminar',
    select: 'Presione Enter para seleccionar',
    selected: 'Seleccionado'
  },
  enter: 'Ingresar',
  upload_failed: 'La carga falló, por favor vuelva a intentarlo',
  due_time: 'Tiempo debido',
  requirement: 'Requisito',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Temporalmente no disponible',
  'Coming soon': 'Próximamente, en breve, pronto'
};
